import "./MainContent.css";
import img from "../../img/avatar.png";
import Particl from "../Particl/Particl";
import ReactTyped from "react-typed";
import Fade from "react-reveal";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

const MainContent = () => {
  return (
    <div className="content">
      <Particl></Particl>
      <div className="container">
        <div className=" text-white  row parent gx-1  d-flex justify-content-center align-items-center ">
          <Fade left duration={2500} distance="40px">
            <div className="col col-lg-6 col-md-6 col-sm-12 col-12">
              <h1 className="fw-bold h1 ">Hi, I’m</h1>
              <h1 className="fw-bold h1 ">Md Riyad Talukder</h1>
              <h2 className="h2">
                <span className="txt">I'm</span>{" "}
                <span>
                  <ReactTyped
                    strings={[
                      "Competitive programmer",
                      "Software Engineer",
                      "Full Stack Engineer",
                      "Back End Engineer",
                    ]}
                    typeSpeed={50}
                    backSpeed={50}
                    loop
                  />
                </span>
              </h2>
              <p className="fs-5 fw-bold">
                A self-motivated Software Engineer and Competitive Programmer
                with strong problem-solving skills and a passion for full stack
                engineer. Always eager to learn new technologies, solve
                challenging problems, and contribute to company growth.
              </p>
              <a
                href="#contact"
                role="button"
                class=" btn btnn text-white fw-bold fs-5  active"
              >
                Hire Me
              </a>
              {/* <a href='https://drive.google.com/u/0/uc?id=1ntl5qJdJD0sr8kiQQSx9p76GrjLHPPy8&export=download' role='button' target='_blank' className='btn btnn text-white fw-bold fs-5  ms-4 '><i class="fas fa-file-download me-1"></i>Resume</a> */}
            </div>
          </Fade>

          <Fade right duration={2500} distance="40px">
            <div className="col col-lg-6 col-md-6 col-sm-12 col-12 imgs">
              <img src={img} alt="" className="img-fluid" />
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
